import React, { Component } from "react";
import { connect } from "react-redux";
import FormElement from "../../forms/form_element";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Button, Row, Col, Grid } from "react-bootstrap";
import Checkbox from "../../forms/checkbox";
import LoadingButton from "../../forms/loading_button/loading_button";
import Multiselect from "react-widgets/lib/Multiselect";
import "./show-form.scss";
import { languageChoices } from "../../../constants/language-choices";
import { itunesCategories } from "../../../data/itunes_categories";
import { itunesCategoryGroups } from "../../../data/itunes_category_groups";
import { seedcastForm } from "../../../lib/forms";
import Divider from "../../lib/divider";
import FormDropDown from "../../lib/form_dropdown";
import ImageUploader from "../../forms/image_uploader/image_uploader";
import QuillEditor from "../../forms/quill";
import { CATEGORIES, ACTIONS, gtagEvent } from "../../../lib/google_analytics";
import { change } from "redux-form";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { slugify } from "../../../lib/strings";

class ShowForm extends Component {
  constructor(props) {
    super(props);
    this.getCategoryGroups = this.getCategoryGroups.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.isSuccess && nextProps.isSuccess) {
      this.props.close();
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.mode === "create") {
      if (
        nextProps.title &&
        nextProps.title !== this.props.title &&
        isEmpty(get(this.props, ["initialValues", "alias"]))
      ) {
        this.props.changeFieldValue("alias", slugify(nextProps.title));
      }
    }
  }

  onSubmit = (...args) => {
    gtagEvent(ACTIONS.SUBMIT, CATEGORIES.SHOW_FORM);
    this.props.handleSubmit(...args);
  };

  onFieldChange = () => {
    gtagEvent(ACTIONS.FILL, CATEGORIES.SHOW_FORM);
  };

  render() {
    const renderMultiselect = ({ input, ...rest }) => (
      <Multiselect
        {...input}
        onBlur={() => input.onBlur()}
        value={input.value || []} // requires value to be an array
        {...rest}
      />
    );

    return (
      <form onSubmit={this.onSubmit} className={"show-form-container"}>
        <Grid fluid>
          <Row>
            <Col md={3} mdOffset={1}>
              <div>
                <Field
                  component={FormElement}
                  InputComponent={ImageUploader}
                  user={this.props.user}
                  label="Image File"
                  name="imageFile"
                  setImageFileData={data => this.props.setImageFileData(data)}
                  onUpload={() => gtagEvent(ACTIONS.UPLOAD, CATEGORIES.SHOW_IMAGE)}
                  mediaFileUUID={
                    this.props.initialValues && this.props.initialValues.imageMediaFileUUID
                  }
                  setImageFileUUID={this.props.setImageFileUUID}
                  setError={this.props.setError}
                  mediaFiles={this.props.mediaFiles}
                  validationErrors={this.props.validationErrors}
                  validationErrorKeyOverride="imageMediaFileUUID"
                />
              </div>
            </Col>
            <Col md={6} mdOffset={1}>
              <div className={"show-form show-" + this.props.mode + "-form"}>
                <div>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    name="title"
                    label="Name"
                    type="text"
                    validationErrors={this.props.validationErrors}
                  />
                </div>
                <div className={"episode-form__quill-container"}>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    InputComponent={QuillEditor}
                    name="description"
                    label="Description"
                    validationErrors={this.props.validationErrors}
                    infoText="A description explaining the content of your show."
                  />
                </div>
                <div>
                  <Field
                    disabled={this.props.mode === "edit"}
                    component={FormElement}
                    onChange={this.onFieldChange}
                    name="alias"
                    label="Custom Link"
                    infoText="A custom link to share your show with others."
                    helpText={
                      <span
                        className="margin-left--small"
                        style={{ textTransform: "lowercase", fontSize: "10px" }}>
                        {`redcircle.com/shows/${this.props.alias}`}
                      </span>
                    }
                    validationErrors={this.props.validationErrors}
                  />
                </div>
                <div>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    RenderHandler={renderMultiselect}
                    name="categoryUUIDs"
                    label="Categories"
                    placeholder="Select 1 or more categories"
                    validationErrors={this.props.validationErrors}
                    maxHeight={200}
                    data={this.getCategoryGroups()}
                    textField="name"
                    valueField="uuid"
                    groupBy="groupName"
                  />
                </div>
                <div>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    name="ownerEmail"
                    label="Contact Email"
                    type="email"
                    validationErrors={this.props.validationErrors}
                  />
                </div>
                <div>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    name="ownerName"
                    label="Author Name"
                    type="text"
                    infoText="The name of the author of the show."
                    validationErrors={this.props.validationErrors}
                  />
                </div>
                <Divider />
                <FormDropDown validationErrors={this.props.validationErrors}>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="subtitle"
                      label="Subtitle"
                      type="text"
                      validationErrors={this.props.validationErrors}
                      infoText="A short version of your description."
                    />
                  </div>

                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      componentClass="textarea"
                      name="summary"
                      label="Apple: Summary"
                      type="textarea"
                      rows="10"
                      infoText="If left blank we will default to description.<br> This will be used for apps that don't support an html description like Apple Podcasts."
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="language"
                      label="Language"
                      type="select"
                      componentClass="select"
                      placeholder="Select a language"
                      validationErrors={this.props.validationErrors}>
                      {languageChoices}
                    </Field>
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="copyright"
                      label="Copyright Info"
                      type="text"
                      infoText="Copyright license for your show."
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field component="input" name="isComplete" type="hidden" />
                  </div>
                  <div>
                    <Field component="input" name="isVisible" type="hidden" />
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="link"
                      label="External Link"
                      type="text"
                      infoText="Fill in if you have a website for your podcast."
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field
                      infoText="Mark true if your show will contain explicit content."
                      component={FormElement}
                      onChange={this.onFieldChange}
                      InputComponent={Checkbox}
                      name="isExplicit"
                      checkboxLabel="Show is Explicit"
                      type="checkbox"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                </FormDropDown>

                <div>
                  <Field component="input" name="imageMediaFileUUID" type="hidden" />
                </div>
              </div>
            </Col>
          </Row>
        </Grid>

        <div className="show-form__footer">
          <Grid fluid>
            <Row>
              <Col xs={6} md={5} mdOffset={1} xsOffset={0}>
                <Button
                  onClick={this.props.close}
                  className="show-form__cancel-button btn btn-secondary btn-large">
                  Cancel
                </Button>
              </Col>
              <Col xs={6} md={5}>
                <LoadingButton
                  isLoading={this.props.isFormLoading}
                  className="show-form__submit-button btn btn-primary btn-large"
                  type="submit">
                  {this.props.mode === "create" ? "Create" : "Save"}
                </LoadingButton>
              </Col>
            </Row>
          </Grid>
        </div>
      </form>
    );
  }

  getCategoryGroups() {
    var data = [];
    var categoryGroups = {};
    for (var groupUUID of Object.keys(itunesCategoryGroups)) {
      var group = itunesCategoryGroups[groupUUID];
      categoryGroups[groupUUID] = group;
    }

    for (var category of itunesCategories) {
      data.push({
        name: category.name,
        uuid: category.uuid,
        groupName: categoryGroups[category.group_uuid]
          ? categoryGroups[category.group_uuid]
          : "Other Categories",
      });
    }

    data.sort(function(a, b) {
      var textA = a.groupName.toUpperCase();
      var textB = b.groupName.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    return data;
  }
}

export var ShowCreateForm = props => <ShowForm {...props} mode="create" />;

export var ShowEditForm = props => <ShowForm {...props} mode="edit" />;

ShowCreateForm = reduxForm({
  form: "show-create",
})(ShowCreateForm);
ShowCreateForm = seedcastForm(ShowCreateForm, { whiteList: ["imageFileData"] });

var formValueSelectorCreate = formValueSelector("show-create");
ShowCreateForm = connect(
  state => {
    return {
      selectedImageMediaFileUUID: formValueSelectorCreate(state, "imageMediaFileUUID"),
      alias: formValueSelectorCreate(state, "alias"),
      title: formValueSelectorCreate(state, "title"),
    };
  },
  {
    changeFieldValue: (field, value) => change("show-create", field, value),
  }
)(ShowCreateForm);

ShowEditForm = reduxForm({
  form: "show-edit",
})(ShowEditForm);
ShowEditForm = seedcastForm(ShowEditForm, { whiteList: ["imageFileData"] });

var formValueSelectorUpdate = formValueSelector("show-edit");
ShowEditForm = connect(state => {
  return {
    selectedImageMediaFileUUID: formValueSelectorUpdate(state, "imageMediaFileUUID"),
    alias: formValueSelectorUpdate(state, "alias"),
  };
})(ShowEditForm);
